import fetch from './fetch';
import EndPoints from '../data/EndPoints';
import Methods from '../data/Methods';

export default (id) => {
	return fetch(Methods.GET, EndPoints.DOCUMENTS_COMPANY.replace(':id', id), null, null, true);
};
